// Hook: GET /api/cases -> the prototype Matter shape, with the fixture
// fallback that fetchMatterList applies when the backend cannot be reached.
// A filtered ask (search, review, area) never falls back - see fetchMatterList.

import { useQuery } from "@tanstack/react-query";
import { fetchMatterList, type MatterListResult } from "../api/mock";

export function useMatterList(search?: string, opts?: { needsReview?: boolean; area?: string }) {
  const needsReview = opts?.needsReview === true;
  const area = opts?.area;
  return useQuery<MatterListResult>({
    queryKey: ["matters", search ?? "", needsReview ? "review" : "", area ?? ""],
    queryFn: () => fetchMatterList(search, { needsReview, area }),
    staleTime: 60_000,
    // Typing must narrow the visible rows, not blink a skeleton per key -
    // within one scope only: the area page and the queue must not open on
    // the plain list's rows under their own title while they load.
    placeholderData: (prev, prevQuery) =>
      prevQuery?.queryKey[2] === (needsReview ? "review" : "") &&
      prevQuery?.queryKey[3] === (area ?? "")
        ? prev
        : undefined,
  });
}
